import {
  BaseService,
  CoreService,
  RequestMethod,
  TokenTypes,
} from '@sans-service-tier/sdk';

export interface AuthorizedRequest {
  type: string;
  action: string;
  id: string;
}

export interface ImpersonationRequest {
  accountId: string;
  authSource: string;
  authScope: string;
}

export interface IAuthorizedResponse {
  readonly authorized: boolean;
}

export interface ImpersonationResponse {
  readonly tokens: {
    readonly id_token: string;
    readonly access_token?: string;
    readonly refresh_token?: string;
  };
}

export class AuthorizationService extends BaseService {
  constructor(sdk: CoreService) {
    super({ configPath: 'services.authorization' });
    this.core = sdk;
  }

  async authorized(params: AuthorizedRequest) {
    const query = params as unknown as Record<string, string>;

    return await this.requestResource('users.authorize', {
      method: RequestMethod.GET,
      tokenType: TokenTypes.ID,
      query,
    });
  }

  async impersonate({
    authScope,
    accountId,
    authSource,
  }: ImpersonationRequest): Promise<ImpersonationResponse> {
    return this.requestResource('users.impersonate', {
      method: RequestMethod.POST,
      tokenType: TokenTypes.ID,
      data: {
        authScope,
        accountId,
        authSource,
      },
    });
  }
}
